module.exports = {
  RED: 'red',
  WHITE: 'white',
  PURPLE: 'purple',
  BLUE: 'blue',
  GRAY: 'gray',
  ORANGE: 'orange',
  BROWN: 'brown',
  BLACK: 'black',
  GREEN: 'green',
  YELLOW: 'yellow',
  BEIGE: 'beige',
  UNKNOWN: 'unknown',
  GOLD: 'gold',
  SILVER: 'silver',
};
